<script>
  import { fade } from 'svelte/transition'
  import {
    currentLocation,
    currentSheet,
    marketSheetItems,
  } from './stores/root.js'
  import { sortBy } from 'underscore'
  import { PencilSquare, Trash } from 'svelte-bootstrap-icons'
  import { formatPrice } from './helpers.js'
  import ConfirmDeleteModal from './ConfirmDeleteModal.svelte'
  import ItemModal from './ItemModal.svelte'

  let deleteItem = null,
    deleteDetailId = null,
    editItem = null,
    showItemModal = false

  $: displayItems = $marketSheetItems
</script>

<div in:fade={{ duration: 500 }}>
  <div class="row mt-4 mb-4 pb-1 mb-2">
    <div class="col-12 mb-4 fs-3">
      {$currentLocation.name}
      {#if $currentSheet}
        - {$currentSheet.displayDate}
      {/if}
    </div>

    <div class="col-6 d-flex justify-content-end">
      <button class="btn btn-primary" on:click={(e) => (showItemModal = true)}
        >Add Item</button
      >
    </div>
  </div>

  <table class="table table-striped table-hover align-middle">
    <thead>
      <tr>
        <th scope="col">Item</th>
        <th scope="col" class="text-center">Price</th>
        <th scope="col" class="text-center">Qty Start</th>
        <th scope="col" class="text-center">Vendor</th>
        <th scope="col" />
      </tr>
    </thead>

    <tbody>
      {#each sortBy(displayItems, 'name') as item}
        <tr>
          <td data-field="name" style="max-width: 250px;">
            {item.itemName}, {item.variationName}
            {#if item.itemNotes}
              <br />
              <small class="text-muted"
                ><strong>Notes: </strong>{item.itemNotes}</small
              >
            {/if}
          </td>
          <td data-field="price" class="text-center">
            {item.price ? formatPrice(item.price, true) : ''}
          </td>
          <td data-field="qtyStart" class="qtyStart text-center">
            {item.qtyStart !== null ? item.qtyStart : ''}
          </td>
          <td data-field="vendor" class="text-center">
            {item.vendorName ? item.vendorName : ''}
          </td>
          <td align="center">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul class="dropdown-menu">
                <li>
                  <div
                    class="dropdown-item d-flex align-items-center"
                    on:click={(e) => {
                      // editItem = item
                      // showItemModal = true
                    }}
                  >
                    <PencilSquare class="me-2" />
                    Edit
                  </div>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <div
                    class="dropdown-item d-flex align-items-center"
                    on:click={() => {
                      deleteItem = item
                      deleteDetailId = item.detailId
                    }}
                  >
                    <Trash class="me-2" />
                    Delete
                  </div>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

{#if deleteItem && deleteDetailId}
  <ConfirmDeleteModal
    item={deleteItem}
    detailId={deleteDetailId}
    on:close={() => {
      deleteItem = null
    }}
    on:delete={async (e) => {
      deleteItem = null
    }}
  />
{/if}

{#if showItemModal}
  <ItemModal
    {editItem}
    on:close={() => {
      showItemModal = false
    }}
    on:save={() => {
      showItemModal = false
    }}
  />
{/if}
